import { Smiley } from "@phosphor-icons/react";

import { UploadAttachmentButton } from "features/attachments";

import EmojiSelector from "common/components/EmojiSelector";
import RenderIf from "common/components/RenderIf";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { useActiveConversationContext } from "../../../context/ActiveConversationContext";
import { useNewConversation } from "../../../hooks/useNewConversation";
import MessageVariables from "./MessageVariables";
import RecordButton from "./RecordButton";
import SettingsPopover from "./SettingsPopover";

interface MessageOptionsProps {
  isMessagingDisabled: boolean;
  uploadedFilesCount: number;
  onFileUpload: (file: File) => void;
  insertText: (text: string) => void;
  ctrlToSend: boolean;
  setCtrlToSend: (val: boolean) => void;
  isRecording: boolean;
  setIsRecording: (val: boolean) => void;
}

export default function MessageOptions({
  isMessagingDisabled,
  uploadedFilesCount,
  onFileUpload,
  insertText,
  ctrlToSend,
  setCtrlToSend,
  isRecording,
  setIsRecording,
}: MessageOptionsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { activeConversation } = useActiveConversationContext();
  const { newConversation } = useNewConversation();

  const participants = activeConversation
    ? activeConversation.participants
    : [newConversation.participant];

  return (
    <div className="flex flex-row gap-1">
      <UploadAttachmentButton
        size="xs"
        isDisabled={isMessagingDisabled}
        currentFileCount={uploadedFilesCount}
        onFileUpload={onFileUpload}
      />

      <RenderIf condition={participants.length === 1}>
        <MessageVariables
          participant={participants[0]}
          isMessagingDisabled={isMessagingDisabled}
          insertText={insertText}
        />
      </RenderIf>

      <RenderIf condition={isDesktop}>
        <EmojiSelector
          onEmojiSelection={insertText}
          buttonProps={{
            size: "xs",
            disabled: isMessagingDisabled,
            children: <Smiley />,
          }}
        />
      </RenderIf>

      {/* Voice recorder button */}
      <RenderIf condition={isDesktop}>
        <RecordButton
          isRecording={isRecording}
          setIsRecording={setIsRecording}
          isDisabled={isMessagingDisabled}
          size="xs"
        />
      </RenderIf>

      <div className="block lg:hidden">
        <SettingsPopover
          ctrlToSend={ctrlToSend}
          setCtrlToSend={setCtrlToSend}
          isDisabled={isMessagingDisabled}
        />
      </div>
    </div>
  );
}
